import script from "./DetailKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./DetailKontraktorPage.vue?vue&type=style&index=0&id=dcff5368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcff5368"]])

export default __exports__